import { getWxAuthSdk } from '@/api/download'
// const getWxAuthSdk = () => {}
import reg from '../utils/reg'
import wx from 'weixin-js-sdk'

// 获取签名url
const url = reg.isApple() ? window.location.href.split('#')[0] : window.location.href
// 微信签名
export const initWx = ((options = {}) => {
  const defaults = {
    debug: false,
  }
  return new Promise((resolve, reject) => {
    getWxAuthSdk({
      pageUrl: url.split('#')[0],
    }).then((resData) => {
      const {
        debug, appId, timestamp, nonceStr, signature,
      } = Object.assign(defaults, options, resData.mdata)
      const config = {
        debug: false,
        appId,
        timestamp,
        nonceStr,
        signature,
        jsApiList: [
          'checkJsApi',
        ],
        openTagList: ['wx-open-launch-weapp'],
      }
      wx.config(config)

      wx.error((res) => {
        console.log(res, 2222)
        if (debug === 'true') {
          alert(`error:${JSON.stringify(res)}`)
        }
        reject(JSON.stringify(res))
      })
      wx.ready((res) => {
        // wx.hideMenuItems({
        //   menuList: ['menuItem:copyUrl', 'menuItem:openWithQQBrowser', 'menuItem:openWithSafari'], // 要隐藏的菜单项，所有menu项见附录3
        // })
        console.log(1111)
        resolve(res)
      })
    }).catch(err => {
      console.log(err, 333)
    })
  })
})

export function wx_launch(info){
    var btn = document.getElementById(info.eleId); //获取元素
    let script = document.createElement("script");// 创建script内容插槽 避免template标签冲突
    script.type = "text/wxtag-template"; // 使用script插槽 必须定义这个type
    script.text = info.content // 自定义的html字符串内容
    // wx-open-launch-weapp
    const pathStr = info.url ? `path=${info.url}` : ''

    const styleStr = 'width: 100px; height: 35px;background: #FFC119;border-radius: 17px;display: flex;align-items: center; justify-content: center; color: #fff;font-size: 16px;'
    let html = `<wx-open-launch-weapp username="${info.appid}" ${pathStr} >${script.outerHTML}</wx-open-launch-weapp>`;

    btn.innerHTML = html; // html字符串赋值

    // 点击按钮 正常跳转触发
    btn.addEventListener("launch", function (e) {
      console.log("success");

    });
    // 点击跳转 抛出异常
    btn.addEventListener("error", function (e) {
      console.log("fail", e.detail);

      // alert(`跳转异常 - ${e.detail}`)
    });
    return Promise.resolve()
}
// 判断是否微信环境
function is_weixn() {
  let ua = navigator.userAgent.toLowerCase()
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    return true
  } else {
    return false
  };
};

// 判断当前微信版本号是否支持
function is_version(){
  let client = false; // 当前版本号是否支持 (默认不支持)
  let wxInfo = navigator.userAgent.match(/MicroMessenger\/([\d\.]+)/i); // 微信浏览器信息
  // 微信版本号 wxInfo[1] = "7.0.18.1740" (示例)
  //进行split转成数组进行判断 [7,0,18,1740] (示例)
  let version = wxInfo[1].split(".");
  // 判断版本在7.0.12及以上的版本
  if (version[0] >= 7) {
    if (version[1] >= 0) {
      if (version[2] >= 12) {
        client = true; // 当前版本支持
      }
    }
  }
  return client;
}

export default {
  initWx,
  wx_launch,
  is_weixn,
  is_version
}
